import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataType } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataType,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    let consult = `Según el significado de las cartas, me puedes proporcionar la interpretación de la tirada de la Cruz Celta para ${
        data.consultante.name
    } que necesita saber sobre lo siguiente: ${data.consulta}, con las siguientes cartas: ${formatCardLabel(cards[0])} en la posicion central o situación actual, ${formatCardLabel(cards[1])} en la influencia, ${formatCardLabel(cards[2])} en el subconsciente, ${formatCardLabel(cards[3])} en el pasado, ${formatCardLabel(cards[4])} en el consciente, ${formatCardLabel(cards[5])} en el futuro cercano, ${formatCardLabel(cards[6])} en el consultante, ${formatCardLabel(cards[7])} en el entorno, ${formatCardLabel(cards[8])} en la solución o consejo y ${formatCardLabel(cards[9])} en el resultado final. Dirígete directamente al consultante, no utilices la tercera persona refiriendote a la consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 parrafos despues de cada respuesta, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }

    return info
}
